import { Box } from "@mui/material";
import React, { useState } from "react";
import SideNavigationLink from "Layouts/SideNavigationNew/SideNavigationLink";
import AddIcon from "@mui/icons-material/Add";
import { CreateDashboardDialog } from "./CreateDashboardDialog";

// Create new dashboard button for when on signals view
export const NewDashboardButton = () => {
    const [createDashboardOpen, setCreateDashboardOpen] = useState(false);
    return (
        <>
            <SideNavigationLink
                val={{
                    title: (
                        <Box
                            id="signals-create-new-dashboard"
                            fontSize="14px"
                            onClick={(e) => {
                                e.preventDefault();
                                setCreateDashboardOpen(true);
                            }}
                        >
                            New Dashboard
                        </Box>
                    ),
                    icon: <AddIcon />,
                    link: "",
                    signalsVariant: true,
                }}
                replaceLinks={{}}
            />
            <CreateDashboardDialog
                open={createDashboardOpen}
                setOpen={setCreateDashboardOpen}
                disabled={false}
            />
        </>
    );
};
